'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EMOJIS_PER_ROW = exports.EMOJI_HEIGHT = exports.CATEGORY_HEADER_HEIGHT = undefined;

var _set = require('babel-runtime/core-js/set');

var _set2 = _interopRequireDefault(_set);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _compact = require('emojibase-data/en/compact.json');

var _compact2 = _interopRequireDefault(_compact);

var _index = require('../../../index');

var _index2 = _interopRequireDefault(_index);

var _languageHandler = require('../../../languageHandler');

var _recent = require('./recent');

var recent = _interopRequireWildcard(_recent);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
Copyright 2019 Tulir Asokan <tulir@maunium.net>

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

var EMOJIBASE_CATEGORY_IDS = ["people", // smileys
"people", // actually people
"control", // modifiers and such, not displayed in picker
"nature", "foods", "places", "activity", "objects", "symbols", "flags"];

var DATA_BY_CATEGORY = {
    "people": [],
    "nature": [],
    "foods": [],
    "places": [],
    "activity": [],
    "objects": [],
    "symbols": [],
    "flags": []
};
var DATA_BY_EMOJI = {};

var VARIATION_SELECTOR = String.fromCharCode(0xFE0F);
_compact2.default.forEach(function (emoji) {
    if (emoji.unicode.includes(VARIATION_SELECTOR)) {
        // Clone data into variation-less version
        emoji = (0, _assign2.default)({}, emoji, {
            unicode: emoji.unicode.replace(VARIATION_SELECTOR, "")
        });
    }
    DATA_BY_EMOJI[emoji.unicode] = emoji;
    var categoryId = EMOJIBASE_CATEGORY_IDS[emoji.group];
    if (DATA_BY_CATEGORY.hasOwnProperty(categoryId)) {
        DATA_BY_CATEGORY[categoryId].push(emoji);
    }
    // This is used as the string to match the query against when filtering emojis.
    emoji.filterString = emoji.annotation + '\n' + emoji.shortcodes.join('\n') + '}\n' + (emoji.emoticon || '');
});

var CATEGORY_HEADER_HEIGHT = exports.CATEGORY_HEADER_HEIGHT = 22;
var EMOJI_HEIGHT = exports.EMOJI_HEIGHT = 37;
var EMOJIS_PER_ROW = exports.EMOJIS_PER_ROW = 8;

var EmojiPicker = function (_React$Component) {
    (0, _inherits3.default)(EmojiPicker, _React$Component);

    function EmojiPicker(props) {
        (0, _classCallCheck3.default)(this, EmojiPicker);

        var _this = (0, _possibleConstructorReturn3.default)(this, (EmojiPicker.__proto__ || (0, _getPrototypeOf2.default)(EmojiPicker)).call(this, props));

        _this.onScroll = function () {
            var body = _this.bodyRef.current;
            _this.setState({
                scrollTop: body.scrollTop,
                viewportHeight: body.clientHeight
            });
            _this.updateVisibility();
        };

        _this.state = {
            filter: "",
            previewEmoji: null,
            scrollTop: 0,
            // initial estimation of height, dialog is hardcoded to 450px height.
            // should be enough to never have blank rows of emojis as
            // 3 rows of overflow are also rendered. The actual value is updated on scroll.
            viewportHeight: 280
        };

        // Convert recent emoji characters to emoji data, removing unknowns.
        _this.recentlyUsed = recent.get().map(function (unicode) {
            return DATA_BY_EMOJI[unicode];
        }).filter(function (data) {
            return !!data;
        });
        _this.memoizedDataByCategory = (0, _extends3.default)({
            recent: _this.recentlyUsed
        }, DATA_BY_CATEGORY);

        _this.categories = [{
            id: "recent",
            name: (0, _languageHandler._t)("Frequently Used"),
            enabled: _this.recentlyUsed.length > 0,
            visible: _this.recentlyUsed.length > 0,
            ref: _react2.default.createRef()
        }, {
            id: "people",
            name: (0, _languageHandler._t)("Smileys & People"),
            enabled: true,
            visible: true,
            ref: _react2.default.createRef()
        }, {
            id: "nature",
            name: (0, _languageHandler._t)("Animals & Nature"),
            enabled: true,
            visible: false,
            ref: _react2.default.createRef()
        }, {
            id: "foods",
            name: (0, _languageHandler._t)("Food & Drink"),
            enabled: true,
            visible: false,
            ref: _react2.default.createRef()
        }, {
            id: "activity",
            name: (0, _languageHandler._t)("Activities"),
            enabled: true,
            visible: false,
            ref: _react2.default.createRef()
        }, {
            id: "places",
            name: (0, _languageHandler._t)("Travel & Places"),
            enabled: true,
            visible: false,
            ref: _react2.default.createRef()
        }, {
            id: "objects",
            name: (0, _languageHandler._t)("Objects"),
            enabled: true,
            visible: false,
            ref: _react2.default.createRef()
        }, {
            id: "symbols",
            name: (0, _languageHandler._t)("Symbols"),
            enabled: true,
            visible: false,
            ref: _react2.default.createRef()
        }, {
            id: "flags",
            name: (0, _languageHandler._t)("Flags"),
            enabled: true,
            visible: false,
            ref: _react2.default.createRef()
        }];

        _this.bodyRef = _react2.default.createRef();

        _this.onChangeFilter = _this.onChangeFilter.bind(_this);
        _this.onHoverEmoji = _this.onHoverEmoji.bind(_this);
        _this.onHoverEmojiEnd = _this.onHoverEmojiEnd.bind(_this);
        _this.onClickEmoji = _this.onClickEmoji.bind(_this);
        _this.scrollToCategory = _this.scrollToCategory.bind(_this);
        _this.updateVisibility = _this.updateVisibility.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(EmojiPicker, [{
        key: 'updateVisibility',
        value: function updateVisibility() {
            var body = this.bodyRef.current;
            var rect = body.getBoundingClientRect();
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = (0, _getIterator3.default)(this.categories), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var cat = _step.value;

                    var elem = body.querySelector('[data-category-id="' + cat.id + '"]');
                    if (!elem) {
                        cat.visible = false;
                        cat.ref.current.classList.remove("mx_EmojiPicker_anchor_visible");
                        continue;
                    }
                    var elemRect = elem.getBoundingClientRect();
                    var y = elemRect.y - rect.y;
                    var yEnd = elemRect.y + elemRect.height - rect.y;
                    cat.visible = y < rect.height && yEnd > 0;
                    // We update this here instead of through React to avoid re-render on scroll.
                    if (cat.visible) {
                        cat.ref.current.classList.add("mx_EmojiPicker_anchor_visible");
                    } else {
                        cat.ref.current.classList.remove("mx_EmojiPicker_anchor_visible");
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    }, {
        key: 'scrollToCategory',
        value: function scrollToCategory(category) {
            this.bodyRef.current.querySelector('[data-category-id="' + category + '"]').scrollIntoView();
        }
    }, {
        key: 'onChangeFilter',
        value: function onChangeFilter(filter) {
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = (0, _getIterator3.default)(this.categories), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var cat = _step2.value;

                    var emojis = void 0;
                    // If the new filter string includes the old filter string, we don't have to re-filter the whole dataset.
                    if (filter.includes(this.state.filter)) {
                        emojis = this.memoizedDataByCategory[cat.id];
                    } else {
                        emojis = cat.id === "recent" ? this.recentlyUsed : DATA_BY_CATEGORY[cat.id];
                    }
                    emojis = emojis.filter(function (emoji) {
                        return emoji.filterString.includes(filter);
                    });
                    this.memoizedDataByCategory[cat.id] = emojis;
                    cat.enabled = emojis.length > 0;
                    // The setState below doesn't re-render the header and we already have the refs for updateVisibility, so...
                    cat.ref.current.disabled = !cat.enabled;
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            this.setState({ filter: filter });
            // Header underlines need to be updated, but updating requires knowing
            // where the categories are, so we wait for a tick.
            setTimeout(this.updateVisibility, 0);
        }
    }, {
        key: 'onHoverEmoji',
        value: function onHoverEmoji(emoji) {
            this.setState({
                previewEmoji: emoji
            });
        }
    }, {
        key: 'onHoverEmojiEnd',
        value: function onHoverEmojiEnd(emoji) {
            this.setState({
                previewEmoji: null
            });
        }
    }, {
        key: 'onClickEmoji',
        value: function onClickEmoji(emoji) {
            if (this.props.onChoose(emoji.unicode) !== false) {
                recent.add(emoji.unicode);
            }
        }
    }, {
        key: '_categoryHeightForEmojiCount',
        value: function _categoryHeightForEmojiCount(count) {
            if (count === 0) {
                return 0;
            }
            return CATEGORY_HEADER_HEIGHT + Math.ceil(count / EMOJIS_PER_ROW) * EMOJI_HEIGHT;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var Header = _index2.default.getComponent("emojipicker.Header");
            var Search = _index2.default.getComponent("emojipicker.Search");
            var Category = _index2.default.getComponent("emojipicker.Category");
            var Preview = _index2.default.getComponent("emojipicker.Preview");
            var QuickReactions = _index2.default.getComponent("emojipicker.QuickReactions");
            var heightBefore = 0;
            return _react2.default.createElement(
                'div',
                { className: 'mx_EmojiPicker' },
                _react2.default.createElement(Header, { categories: this.categories, defaultCategory: 'recent', onAnchorClick: this.scrollToCategory }),
                _react2.default.createElement(Search, { query: this.state.filter, onChange: this.onChangeFilter }),
                _react2.default.createElement(
                    'div',
                    { className: 'mx_EmojiPicker_body', ref: this.bodyRef, onScroll: this.onScroll },
                    this.categories.map(function (category) {
                        var emojis = _this2.memoizedDataByCategory[category.id];
                        var categoryElement = _react2.default.createElement(Category, { key: category.id, id: category.id, name: category.name,
                            heightBefore: heightBefore, viewportHeight: _this2.state.viewportHeight,
                            scrollTop: _this2.state.scrollTop, emojis: emojis, onClick: _this2.onClickEmoji,
                            onMouseEnter: _this2.onHoverEmoji, onMouseLeave: _this2.onHoverEmojiEnd,
                            selectedEmojis: _this2.props.selectedEmojis });
                        var height = _this2._categoryHeightForEmojiCount(emojis.length);
                        heightBefore += height;
                        return categoryElement;
                    })
                ),
                this.state.previewEmoji || !this.props.showQuickReactions ? _react2.default.createElement(Preview, { emoji: this.state.previewEmoji }) : _react2.default.createElement(QuickReactions, { onClick: this.onClickEmoji, selectedEmojis: this.props.selectedEmojis })
            );
        }
    }]);
    return EmojiPicker;
}(_react2.default.Component);

EmojiPicker.propTypes = {
    onChoose: _propTypes2.default.func.isRequired,
    selectedEmojis: _propTypes2.default.instanceOf(_set2.default),
    showQuickReactions: _propTypes2.default.bool
};
exports.default = EmojiPicker;
//# sourceMappingURL=EmojiPicker.js.map